var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.7666 -1.40039V15.3996H20.6334V-1.40039H-1.7666Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22446_26939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -2,
    width: 23,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.7666 -1.40039V15.3996H20.6334V-1.40039H-1.7666Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22446_26939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.26099 14.2005L0.668196 16.2852L20.7451 0.867223L23.3451 -2.23061L18.074 -2.92736L9.88517 3.71667L3.29397 8.19319L-4.26099 14.2005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.58618 15.6613L-1.07499 16.8711L22.4114 -2.51816H18.8854L-3.58618 15.6613Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1274 14.2005L18.1983 16.2852L-1.8786 0.867223L-4.47863 -2.23061L0.792416 -2.92736L8.98129 3.71667L15.5725 8.19319L23.1274 14.2005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9592 15.2492L20.448 16.459L10.4473 8.15744L7.48227 7.22992L-4.72884 -2.21951H-1.20284L11.0014 7.00563L14.2431 8.11782L22.9592 15.2492Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_22446_26939",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0777 -2.79883H6.78882V4.20117H-3.14746V9.80117H6.78882V16.8012H12.0777V9.80117H22.0525V4.20117H12.0777V-2.79883Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0777 -2.79883H6.78882V4.20117H-3.14746V9.80117H6.78882V16.8012H12.0777V9.80117H22.0525V4.20117H12.0777V-2.79883Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78882 -2.79883V-4.79883H4.78882V-2.79883H6.78882ZM12.0777 -2.79883H14.0777V-4.79883H12.0777V-2.79883ZM6.78882 4.20117V6.20117H8.78882V4.20117H6.78882ZM-3.14746 4.20117V2.20117H-5.14746V4.20117H-3.14746ZM-3.14746 9.80117H-5.14746V11.8012H-3.14746V9.80117ZM6.78882 9.80117H8.78882V7.80117H6.78882V9.80117ZM6.78882 16.8012H4.78882V18.8012H6.78882V16.8012ZM12.0777 16.8012V18.8012H14.0777V16.8012H12.0777ZM12.0777 9.80117V7.80117H10.0777V9.80117H12.0777ZM22.0525 9.80117V11.8012H24.0525V9.80117H22.0525ZM22.0525 4.20117H24.0525V2.20117H22.0525V4.20117ZM12.0777 4.20117H10.0777V6.20117H12.0777V4.20117ZM6.78882 -0.798828H12.0777V-4.79883H6.78882V-0.798828ZM8.78882 4.20117V-2.79883H4.78882V4.20117H8.78882ZM-3.14746 6.20117H6.78882V2.20117H-3.14746V6.20117ZM-1.14746 9.80117V4.20117H-5.14746V9.80117H-1.14746ZM6.78882 7.80117H-3.14746V11.8012H6.78882V7.80117ZM8.78882 16.8012V9.80117H4.78882V16.8012H8.78882ZM12.0777 14.8012H6.78882V18.8012H12.0777V14.8012ZM10.0777 9.80117V16.8012H14.0777V9.80117H10.0777ZM22.0525 7.80117H12.0777V11.8012H22.0525V7.80117ZM20.0525 4.20117V9.80117H24.0525V4.20117H20.0525ZM12.0777 6.20117H22.0525V2.20117H12.0777V6.20117ZM10.0777 -2.79883V4.20117H14.0777V-2.79883H10.0777Z",
    fill: "white",
    mask: "url(#path-7-inside-1_22446_26939)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEn);
export default __webpack_public_path__ + "static/media/ic_en.5800181fec5edd75ed9b17b6b2834804.svg";
export { ForwardRef as ReactComponent };